import React, { useEffect, useState, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Reveal, SectionHeading } from "../shared/Primitives";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

export default function Testimonials({ testimonials }) {
    const [emblaRef, embla] = useEmblaCarousel({ loop: true, align: "start" });
    const [selected, setSelected] = useState(0);
    const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
    const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);
    useEffect(() => {
        if (!embla) return;
        const onSelect = () => setSelected(embla.selectedScrollSnap());
        embla.on("select", onSelect); onSelect();
    }, [embla]);

    if (!testimonials?.length) return null;
    return (
        <section className="max-w-6xl mx-auto px-5 py-24 md:py-32">
            <div className="flex items-end justify-between">
                <SectionHeading id="testimonials" index="08 / Voices" subtitle="Testimonials" title="What people say about working with me." />
                <div className="hidden sm:flex gap-2 mb-20">
                    <button data-testid="testimonial-prev" onClick={scrollPrev} className="w-10 h-10 grid place-items-center glass rounded-full hover:text-primary transition-colors"><ChevronLeft className="w-4 h-4" /></button>
                    <button data-testid="testimonial-next" onClick={scrollNext} className="w-10 h-10 grid place-items-center glass rounded-full hover:text-primary transition-colors"><ChevronRight className="w-4 h-4" /></button>
                </div>
            </div>
            <Reveal>
                <div className="overflow-hidden" ref={emblaRef} data-testid="testimonials-carousel">
                    <div className="flex gap-5">
                        {testimonials.map((t) => (
                            <div key={t.id} className="min-w-0 flex-[0_0_100%] md:flex-[0_0_50%] lg:flex-[0_0_40%]">
                                <div className="glass rounded-3xl p-7 h-full flex flex-col gradient-border">
                                    <Quote className="w-8 h-8 text-primary/40 mb-4" />
                                    <p className="text-base sm:text-lg leading-relaxed flex-1">{`"${t.quote}"`}</p>
                                    <div className="flex items-center gap-3 mt-6">
                                        <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                                        <div>
                                            <div className="font-medium text-sm">{t.name}</div>
                                            <div className="text-xs text-muted-foreground">{t.role}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Reveal>
            <div className="flex justify-center gap-2 mt-8">
                {testimonials.map((_, i) => (
                    <button key={i} onClick={() => embla && embla.scrollTo(i)} data-testid={`testimonial-dot-${i}`}
                        className={`h-1.5 rounded-full transition-all ${selected === i ? "w-8 bg-primary" : "w-2 bg-muted-foreground/40"}`} />
                ))}
            </div>
        </section>
    );
}
